import { useEffect, useState } from "react";
import SbuxEnhancedTable from "../../../../components/SbuxTable/SbuxEnhancedTable";
import SbuxTranslate from "../../../../components/SbuxTranslate";
import QuickConnectsRow from "./QuickConnectsRow";
import { quickConnectsColumns, quickConnectsFilterColumns } from "./columns";
import { CONTACT_CONNECTED_STATUS } from "../../../../constants";

interface QuickConnectsTableProps {
  endpoints: Record<string, unknown>[] | null | undefined;
  ccpContactStatus: string | null;
  filteredItem: string[];
  setFilteredItem?:
    | ((items: string[]) => { type: string; [key: string]: unknown })
    | null;
  quickConnectsReset: boolean;
}

const QuickConnectsTable = ({
  endpoints,
  ccpContactStatus,
  filteredItem,
  setFilteredItem,
  quickConnectsReset,
}: QuickConnectsTableProps) => {
  const [rows, setRows] = useState<Record<string, unknown>[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 100);
  }, []);

  useEffect(() => {
    if (endpoints && endpoints.length > 0) {
      const reducedRows = endpoints.reduce<Record<string, unknown>[]>(
        (acc, cur, index) => {
          const curValues = Object.values(cur);
          const isExists = curValues.some((f) =>
            filteredItem.includes(f as string),
          );
          if (isExists) {
            acc.push({
              id: index,
              ...cur,
            });
          }
          return acc;
        },
        [],
      );
      const mappedRows =
        ccpContactStatus === CONTACT_CONNECTED_STATUS
          ? reducedRows
          : reducedRows.filter((endpoint) => endpoint.phoneNumber !== null);
      setRows(mappedRows);
    }
  }, [endpoints, ccpContactStatus, filteredItem]);

  return (
    <SbuxEnhancedTable
      rows={quickConnectsReset && filteredItem.length === 0 ? [] : rows}
      filterColumns={quickConnectsFilterColumns}
      filterTitle={"Quick Connects Filter"}
      columns={quickConnectsColumns}
      defaultSortingField={"name"}
      defaultSortOrder={"asc"}
      defaultFilterColumns={filteredItem}
      setFilteredItem={setFilteredItem}
      RowSource={QuickConnectsRow}
      isLoading={isLoading}
      footerMarginBottom={"0"}
    />
  );
};

export default QuickConnectsTable;
